// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"46b9a57c","560":"735c15a8"}[chunkId] + ".chunk.js";
};